import styled from 'styled-components'

export const FormLogo = styled.p`
  margin-left: 12px;
  font-size: 1.9em;
`;